/**
 *
 * Asynchronously loads the component for ClientDetailsPage
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
